import React, { FC } from "react";
import { createContext } from "react";

export interface MultiFileUploaderContextValues {
  selectedFiles: FileList,
  setSelectedFiles: React.Dispatch<React.SetStateAction<FileList>>;
  setUploadedFiles: React.Dispatch<React.SetStateAction<Map<number, File>>>;
  uploadedFiles: Map<number, File>
}

const initialValues: MultiFileUploaderContextValues = {
  selectedFiles: null,
  setSelectedFiles: () => null,
  setUploadedFiles: () => null,
  uploadedFiles: null
}

const DragAndDropMultiFileUploaderContext = createContext(initialValues);

const DragAndDropMultiFileUploaderContextProvider: FC<{ children: React.ReactNode }> = (props: { children: React.ReactNode }) => {
  
  const [selectedFiles, setSelectedFiles] = React.useState<FileList>(null);
  const [uploadedFiles, setUploadedFiles] = React.useState<Map<number, File>>(new Map());

  const contextValues : MultiFileUploaderContextValues = {
    selectedFiles,
    setSelectedFiles,
    setUploadedFiles,
    uploadedFiles
  }

  return (
    <DragAndDropMultiFileUploaderContext.Provider value={contextValues}>
      {props.children}
    </DragAndDropMultiFileUploaderContext.Provider>
  );

}

export {DragAndDropMultiFileUploaderContext, DragAndDropMultiFileUploaderContextProvider}

